// extracted by mini-css-extract-plugin
export default {"right-panel":"SidePanel_right-panel__W5Q4h"};